export default __webpack_public_path__ + "static/media/Arrow2.961a8fa9.svg";